/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import BaseProductTile, {Skeleton} from '@salesforce/retail-react-app/app/components/product-tile';

import {PRODUCT_TILE_DYNAMIC_IMAGE_PROPS} from '@amblique/base/app/constants';
import {transformer} from '@amblique/base/app/helpers/transformer';

/**
 * @override
 *  - Add default `dynamicImageProps` property
 *  - Checks and transform `product_detail` object to `product_search_hit`
 *
 * @todo
 *  - Handle product tile actions and behaviors inside the component itself
 */
const ProductTile = ({
  product,
  dynamicImageProps = PRODUCT_TILE_DYNAMIC_IMAGE_PROPS,
  ...props
}) => {
  if (!product.hitType) {
    product = transformer.transformProductToSearchHit(product);
  }

  return <BaseProductTile dynamicImageProps={dynamicImageProps} product={product} {...props} />;
};

ProductTile.displayName = BaseProductTile.displayName;
ProductTile.propTypes = BaseProductTile.propTypes;

export default ProductTile;
export {Skeleton};
